define(function(require, exports, module) {
    'use strict';
    var Class = require('Class');
    var _ = require('underscore');
    var AnimationManagerCore = require('managers/animation.manager');

    var _animationsExclusionClasses = {
        'info-list__row': ['fn-accordion', 'fn-multiview-bonus'],
        'btn': ['no-animation']
    };

    var AnimationManager = Class.create(AnimationManagerCore, {

        _filterByExclusionClass: function(el, animationClass) {
            var exclusionClass = _animationsExclusionClasses[animationClass];

            // HACK: exclude elements with 'exclusion' classes
            if (_.isArray(exclusionClass)) {
                return Boolean(_.find(exclusionClass, function(cls) {
                    return el.classList.contains(cls);
                }));
            } else if (exclusionClass && el.classList.contains(exclusionClass)) {
                return true;
            }

            return false;
        },
    });

    module.exports = AnimationManager;
});
